import { getContext } from '@fiverr-private/fiverr_context';
import { getIsUserInFeesRegulatedState } from '../getIsUserInFeesRegulatedState/getIsUserInFeesRegulatedState';

interface GetShouldDisplayFees {
    regionCode?: string;
}

export const getShouldDisplayFees = ({ regionCode = '' }: GetShouldDisplayFees): boolean => {
    const { countryCode } = getContext();
    return getIsUserInFeesRegulatedState(countryCode, regionCode);
};
